import { render } from "./cutaway.vue?vue&type=template&id=6cc84a2a"
import script from "./cutaway.vue?vue&type=script&lang=js"
export * from "./cutaway.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__